

exports.__esModule = true;
exports.$AddFiPageRoute = undefined;

require('xo-wallet-components/src/add-card/route');

require('xo-wallet-components/src/add-bank/route');

require('./directive');

var _squid = require('squid');

var $AddFiPageRoute = exports.$AddFiPageRoute = _squid.$ComponentRoute.extend('$AddFiPageRoute', {

    path: 'pageAddFi',

    directive: 'xo-page-add-fi-page',

    query: ['cause', 'message'],

    titleContent: 'addCard.addPaymentMethod',

    trackingData: {
        templateName: 'addFi.dust',
        pageGoal: 'Add Funding Instrument',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-fi',
                'pagename2': '%::fullpage-add-fi:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel'
        }
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel'
        }
    }]
});

angular.value("$AddFiPageRoute", $AddFiPageRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-fi/route.js
 ** module id = 391
 ** module chunks = 1
 **/